/*
 *                   ___====-_  _-====___
 *             _--^^^#####//      \\#####^^^--_
 *          _-^##########// (    ) \\##########^-_
 *         -############//  |\^^/|  \\############-
 *       _/############//   (@::@)   \############\_
 *      /#############((     \\//     ))#############\
 *     -###############\\    (oo)    //###############-
 *    -#################\\  / VV \  //#################-
 *   -###################\\/      \//###################-
 *  _#/|##########/\######(   /\   )######/\##########|\#_
 *  |/ |#/\#/\#/\/  \#/\##\  |  |  /##/\#/  \/\#/\#/\#| \|
 *  `  |/  V  V  `   V  \#\| |  | |/#/  V   '  V  V  \|  '
 *     `   `  `      `   / | |  | | \   '      '  '   '
 *                      (  | |  | |  )
 *                     __\ | |  | | /__
 *                    (vvv(VVV)(VVV)vvv)
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                神兽保佑            永无BUG
 */

export function byte2MB (val) {
    let newData = parseFloat(val)/1024/1024
    return newData.toFixed(2);
}
export function byte2GB (val) {
    let newData = parseFloat(val)/1024/1024/1024
    return newData.toFixed(2);
}
export function byte2Auto (val) {
    let newData
    newData = parseFloat(val)/1024
    if(newData<1024){
        return newData.toFixed(2) + ' KB'
    }else{
        newData = parseFloat(val)/1024/1024
        if(newData<1024){
            return newData.toFixed(2) + ' MB'
        }else{
            newData = parseFloat(val)/1024/1024/1024
            if(newData<1024){
                return newData.toFixed(2) + ' GB'
            }else{
                newData = parseFloat(val)/1024/1024/1024/1024
                if(newData<1024){
                    return newData.toFixed(2) + ' TB'
                }else{
                    return newData.toFixed(2) + ' PB'
                }
            }
        }
    }
}
export function colorpicks(a1,stepall1){
    let a = a1
    let stepall = stepall1
    let step = getStepList(stepall,a.length-1)

    let colorIndex = 0
    let allColor = []
    while (a.length>1&&colorIndex!=a.length-1) {
      let site = gradientColor(a[colorIndex],a[colorIndex+1],step[colorIndex])
      allColor = [...allColor,...site]
      colorIndex++
    }
    console.log(allColor);
    return allColor
}
function getStepList(val,step){
    let a = parseInt(val/step)
    let b = val%step
    let c = []
    for(let i=0;i<step;i++){
        c.push(a)
    }
    for(let i=0;i<b;i++){
        c[i] = c[i]+1
    }
    console.log(c);
    return c
}
function gradientColor(startColor,endColor,step){
    let startRGB = colorToRgb(startColor);//转换为rgb数组模式
    let startR = startRGB[0];
    let startG = startRGB[1];
    let startB = startRGB[2];

    let endRGB = colorToRgb(endColor);
    let endR = endRGB[0];
    let endG = endRGB[1];
    let endB = endRGB[2];

    let sR = (endR-startR)/step;//总差值
    let sG = (endG-startG)/step;
    let sB = (endB-startB)/step;

    var colorArr = [];
    for(var i=0;i<step;i++){
        var hex = colorToHex2('rgb('+parseInt((sR*i+startR))+','+parseInt((sG*i+startG))+','+parseInt((sB*i+startB))+')');
        colorArr.push(hex);
    }
    return colorArr;
}

    // 将hex表示方式转换为rgb表示方式(这里返回rgb数组模式)
function colorToRgb(ssColor){
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var sColor = ssColor.toLowerCase();
    if(sColor && reg.test(sColor)){
        if(sColor.length === 4){
            var sColorNew = "#";
            for(var i=1; i<4; i+=1){
                sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
            }
            sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for(var c=1; c<7; c+=2){
            sColorChange.push(parseInt("0x"+sColor.slice(c,c+2)));
        }
        return sColorChange;
    }else{
        return sColor;
    }
}

    // 将rgb表示方式转换为hex表示方式
function colorToHex2(data){
    let reg = /^(rgb|RGB)/;
    let color = data;
    if (reg.test(color)) {
        let strHex = "#";
        // 把RGB的3个数值变成数组
        let colorArr = color.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        // 转成16进制
        for (let i = 0; i < colorArr.length; i++) {
            let hex = Number(colorArr[i]).toString(16);
            if (hex.length == "1") { hex = "0" + hex; }
            strHex += hex;
        }
        return strHex;
    }
    else { return color.toString(); }
}
import {Message} from 'element-ui' // 项目用的element ui
import axios from 'axios'
export function promisShow(val){
    let depidSto = sessionStorage.getItem('userInfo')
    let depid
    let message = '抱歉，您的权限不足！'
    if(depidSto){
        depid = JSON.parse(depidSto).depid
        switch (val) {
            case 2:
                if(depid == '5aa0a4e4dbb24ddd821c2167b255bdb2' || depid == '593c3ca5f8a442c485b558f1b5fef328'){
                    return false
                }else{
                    Message({
                        message,
                        type: 'warning',
                        duration: 4 * 1000
                    });
                    return true
                }
            case 3:
                //三级 管理员
                if(depid == '593c3ca5f8a442c485b558f1b5fef328'||depid =='02'){
                    return false
                }else{
                    Message({
                        message,
                        type: 'warning',
                        duration: 4 * 1000
                    });
                    return true
                }
            default:
                return false
        }
    }else{
        //一级  普通用户
        // depid = 'e5b53640a82149e18cf3500702d83092'
        axios.get('config/AllUrl.json').then(res => {
            if (res) {
                let sevice = "http://" + window.location.host +'/';
                window.location.href = res.loginHeader+'?service='+encodeURIComponent(sevice)
            }
        })
    }
}


/**
 * @description: 复制到剪切板
 * @brief: 
 * @Author: chenwei
 * @Date: 2022-07-12 11:36:24
 * @param {*} val
 * @return {*}
 */
export function clipboard(val){
    const el = document.createElement('input');
    el.setAttribute('value', val);
    document.body.appendChild(el);
    el.select();
    const flag = document.execCommand('copy');
    document.body.removeChild(el);
    flag && this.$message.success('已复制到剪切板！');
}